import { render } from "./OrderConfirmed.vue?vue&type=template&id=48dbe077&bindings={}"
import script from "./OrderConfirmed.vue?vue&type=script&lang=js"
export * from "./OrderConfirmed.vue?vue&type=script&lang=js"
script.render = render

export default script